export default __webpack_public_path__ + "static/media/fms-48.7c36d995.jpg";